// extracted by mini-css-extract-plugin
module.exports = {"header":"InventoryItemOrders_header_2G_nt","export":"InventoryItemOrders_export_3EXQc"};